/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useMemo } from 'react';
import ApexCharts, { ApexOptions } from 'apexcharts';
import { useThemeMode } from '../../../_metronic/partials/layout/theme-mode/ThemeModeProvider';

type Props = {
    className: string;
    chartColor: string;
    chartHeight: string;
    series: any[];
    title: string;
};

const ApexChartBar: React.FC<Props> = ({ className, chartColor, chartHeight, series, title }) => {
    const chartRef = useRef<HTMLDivElement | null>(null);
    const chartInstance = useRef<ApexCharts | null>(null);
    const { mode } = useThemeMode();

    const barchartOptions = useMemo(() => {
        return {
            chart: {
                type: 'bar',
            },
            plotOptions: {
                bar: {
                    horizontal: true,
                    borderRadius: 5,
                }
            },
            colors: [chartColor],
            series: [
                {
                    data: series,
                },
            ],
        };
    }, [series]);

    useEffect(() => {
        if (!chartRef.current) {
            return;
        }

        if (chartInstance.current) {
            chartInstance.current.destroy();
        }

        chartInstance.current = new ApexCharts(chartRef.current, barchartOptions);
        chartInstance.current.render();

        return () => {
            if (chartInstance.current) {
                chartInstance.current.destroy();
            }
        };
    }, [barchartOptions, mode]);

    return (
        <div className={`card ${className}`}>
            <div className="card-body pt-7 pb-0 d-flex flex-column">
                <h1>{title}</h1>
                <div ref={chartRef} className="card-rounded-top"></div>
            </div>
        </div>
    );
};

export { ApexChartBar };
